import React, { useEffect, useState, useRef } from "react";
import { Config } from "config";
import { Tabs } from "cms/shared/tabs";
import { TabContent } from "cms/shared/tabs/tab-content";
import { isArrayEmpty, isArrayNotEmpty } from "cms/utils/empty-exists";

import L from "leaflet";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import "react-leaflet-markercluster/styles";
import "proj4leaflet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "assets/icons";
import ReactDOMServer from "react-dom/server";
import { Link } from "react-router-dom";

import * as devAppService from "./devapp-service";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
import { DATE_STORAGE_FORMAT } from "cms/fields/dates/date-helpers";
import {
    Autocomplete,
    TextField,
    OutlinedInput,
    InputLabel,
    MenuItem,
    FormControl,
    ListItemText,
    Select,
    Checkbox,
} from "@mui/material";
import { PaginationControl } from "mydnv/components/pagination";
import MarkerClusterGroup from "react-leaflet-markercluster";

const ChangeLocation = (data) => {

    const map = useMap();
    if (data.resetMap === true) {
        map.setView(data.location, data.zoom);
    }

    // disable map dragging when info-window is open
    if (data.overLayInfo) {
        map.dragging.disable();
    } else {
        map.dragging.enable();
    }
};

const DnvMapSearch = (props) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // development type filter
    const selectDevRef = useRef(null);
    const [devWidth, setDevWidth] = useState(0);
    // neighbourhoods filter
    const selectHoodsRef = useRef(null);
    const [hoodsWidth, setHoodsWidth] = useState(0);
    const applicationsPerPage = 10;
    const mapCenter = [49.337414, -123.070565];
    const maxMapZoom = 8;
    const minMapZoom = 0;
    const [mapLocation, setMapLocation] = useState(mapCenter);
    const [mapZoom, setMapZoom] = useState(0); // '0' sets deafult zoom on map
    const [overlayInfo, setOverlayInfo] = useState(undefined);
    const [mainImage, setMainImage] = useState({});
    const [devAppInfo, setDevAppInfo] = useState([]);
    const [filteredSearchResults, setFilteredSearchResults] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [paginationDisplayableApplications, setPaginationDisplayableApplications] = useState([]);
    const [paginationStart, setPaginationStart] = useState(0);
    const [paginationEnd, setPaginationEnd] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [endItemOffset, setEndItemOffset] = useState(applicationsPerPage);
    const [totalPages, setTotalPages] = useState(1);
    const [resetMap, setResetMap] = useState(true);
    const [acListOpen, setACListOpen] = useState(false);
    const [showNoResults, setShowNoResults] = useState(false);
    const [sortField, setSortField] = useState("");
    const [order, setOrder] = useState("asc");
    const [resetPage, setResetPage] = useState(false);

    const northWestBound = { lat: 49.67, lng: -123.55 };
    const southEastBound = { lat: 48.96, lng: -122.6 };
    const bounds = L.latLngBounds(northWestBound, southEastBound);
    const crs = new L.Proj.CRS("EPSG:26910", "+proj=utm +zone=10 +ellps=GRS80 +datum=NAD83 +units=m +no_defs", {
        origin: [474584, 5480125],
        resolutions: [
            21.16670900008467, 10.583354500042335, 5.291677250021167, 2.6458386250105836, 1.3229193125052918,
            0.6614596562526459, 0.26458386250105836, 0.13229193125052918, 0.06614596562526459,
        ],
    });
    const apiRootUrl = props.configuration.apiRootUrl;
    // const apiRootUrl = "https://localhost:7218/api/v1/significant-development-application/all";

    const tabs = [
        { id: 0, text: "Map view" },
        { id: 1, text: "List view" },
    ];
    const [selected, setSelected] = useState(0);

    const neighbourhoods = [
        "Deep Cove",
        "Delbrook / Upper Lonsdale",
        "Lions Gate / Lower Capilano",
        "Lynn Creek",
        "Lynn Valley",
        "Maplewood",
        "Seymour",
        "Upper Capilano",
    ];

    const developmentTypes = ["Townhouse", "Apartment", "Commercial", "Institutional", "Industrial"];

    const statuses = ["Ongoing", "Completed"];

    const [filterFormState, setFilterFormState] = useState({
        developmentType: developmentTypes,
        status: statuses,
        neighbourhood: neighbourhoods,
    });

    const iconHTML = ReactDOMServer.renderToString(
        <span className="fa-layers fa-fw fa-lg">
            <FontAwesomeIcon icon={regular.faCircle} className="outline" transform={"grow-20"} />
            <FontAwesomeIcon
                icon={solid.faCircle}
                //size='2xl'
                transform={"grow-16"}
            />
            <FontAwesomeIcon icon={solid.faBuilding} size="lg" />
        </span>,
    );
    const icon = L.divIcon({
        html: iconHTML,
        iconSize: [20, 20],
        className: "myDivIcon",
    });

    const chooseSelected = (id) => {
        setSelected(id);
        // reset pagination when moving between list and calendar TODO
        // to(0);
    };

    const formatDate = (date, format) => {
        // let date = new Date(dateString);
        let dateInZone = dayjs.tz(date, DATE_STORAGE_FORMAT, "America/Vancouver");
        // return dayjs(date).utc(true).local().format('YYYY-MM-DD');
        return dateInZone.format(format);
    };

    useEffect(() => {
        devAppService
            .getAllDevelopmentApplicationsCached(apiRootUrl)
            .then(async (res) => {
                // add list view properties
                const tempData = Object.values(res.data);
                console.log(tempData);
                const apps = mapListViewArray(tempData);
                setDevAppInfo(apps);
                setFilteredSearchResults(apps);
                // console.log(Object.values(res.data));

                if (apps.length > 0) {
                    setPaginationStart(1);
                    setPaginationEnd(applicationsPerPage);
                    updatePaginationDetails(1, apps);
                    setTotalPages(Math.ceil(apps.length / applicationsPerPage));
                }
            })

            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        if (overlayInfo) {
            getMainImage();
        }
    }, [overlayInfo]);

    const mapSelectParcel = async (parcel) => {
        if (parcel) {
            console.log(parcel);
            setOverlayInfo(parcel);
            setMapLocation([parcel.latitude, parcel.longitude]);
            setMapZoom(maxMapZoom);
            setResetMap(true);
        } else {
            setOverlayInfo(undefined);
            setMapLocation(mapCenter);
            setMapZoom(minMapZoom);
            setResetMap(false);
        }
    };

    const getSearchResults = (selectedAddress) => {
        if (selectedAddress === null || selectedAddress === "") {
            setFilteredSearchResults(devAppInfo);
            mapSelectParcel(null);
            updatePaginationDetails(1, devAppInfo);
        } else {
            const searchResults = devAppInfo.filter((devapp) => 
                devapp.planAddress.toLowerCase().includes(selectedAddress.toLowerCase()));
            setFilteredSearchResults(searchResults);
            mapSelectParcel(null);
            let startingPosition = searchResults.length === 0 ? 0 : 1;
            updatePaginationDetails(startingPosition, searchResults);
            setResetMap(true);
            if(searchResults.length === 0){
                setShowNoResults(true);
            }
        }

        setTotalPages(Math.ceil(filteredSearchResults / applicationsPerPage));
    };

    const updatePaginationDetails = (newStartingPosition, applications = filteredSearchResults) => {
        let paginationPositionLimit = newStartingPosition + applicationsPerPage;
        setPaginationStart(newStartingPosition);
        setPaginationEnd(paginationPositionLimit);

        const tempArr = applications.filter((_, index) => index + 1 >= newStartingPosition && index + 1 < paginationPositionLimit);

        // if(tempArr[0].caseNumber){
        //     const simpleArr = mapListViewArray(tempArr);
        //     setPaginationDisplayableApplications(simpleArr);
        //     console.log("simple arr: ", simpleArr)
        // } else {
            setPaginationDisplayableApplications(tempArr);
            console.log("tempArr: ", tempArr);
        // }
        
        let currentPage = 1;
        if (newStartingPosition > 1) {
            currentPage = ((newStartingPosition - 1) / applicationsPerPage) + 1;
        }
        const tempEndItem = calculateEndItem(currentPage, applications);
        setItemOffset(newStartingPosition);

        setEndItemOffset(tempEndItem);
        if (totalPages === currentPage + 1 && newStartingPosition === currentPage * applicationsPerPage + 1) {
            setEndItemOffset(filteredSearchResults.length);
        }
    };

    const calculateEndItem = (currPage, applications = filteredSearchResults) => {
        let endCount = currPage * applicationsPerPage;
        // if (currPage > 1) {
        //     endCount = endCount - 1;
        // }
        if (endCount > applications.length) {
            endCount = applications.length;
        }
        return endCount;
    };

    const onChangeHandler = (e) => {
        if (e.target.value.includes("Select / Deselect all")) {
            let allOptions = "";
            switch (e.target.name) {
                case "developmentType":
                    allOptions = developmentTypes.join(",");
                    break;
                case "status":
                    allOptions = statuses.join(",");
                    break;
                case "neighbourhood":
                    allOptions = neighbourhoods.join(",");
                    break;
            }

            if (filterFormState[e.target.name].join(",") === allOptions) {
                setFilterFormState({
                    ...filterFormState,
                    [e.target.name]: [], // deselect all
                });
            } else {
                setFilterFormState({
                    ...filterFormState,
                    [e.target.name]: allOptions.split(","), // select all
                });
            }
        } else {
            setFilterFormState({
                ...filterFormState,
                [e.target.name]: typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value,
            });
        }
        // stops map from resetting position / zoom
        setResetMap(false);
    };

    const applyFilters = (event) => {
        event.preventDefault();
        let filteredResults = devAppInfo;
        setShowNoResults(false);
        setSearchText("");
        if (event.type === "reset") {
            setFilterFormState({
                developmentType: developmentTypes,
                status: statuses,
                neighbourhood: neighbourhoods,
            });
            // mapSelectParcel(null);
            // setMapLocation(mapCenter);
            let tempEnd = applicationsPerPage;
            if (filteredSearchResults.length <= applicationsPerPage) {
                tempEnd = filteredSearchResults.length;
            }
            setEndItemOffset(tempEnd);
        } else {
            if (filterFormState.developmentType?.length > 0 && filterFormState.developmentType?.length !== developmentTypes.length) {
                filteredResults = filteredResults.filter((devapp) =>
                    devapp.planCustomFieldTableCells.some(
                        (field) =>
                            field.tableName === "Pl Building Proposed" &&
                            field.value !== null &&
                            filterFormState.developmentType.includes(
                                // field.columnName.substring(0, field.columnName.length - 6),
                                field.columnName.split(" ")[0]
                            ),
                    ),
                );
            }
            if (filterFormState.status?.length === 1) {
                if (filterFormState.status[0] === "Ongoing") {
                    filteredResults = filteredResults.filter(
                        (devapp) =>
                            devapp.milestonesCouncilConsidPermitIssD === null ||
                            new Date(devapp.milestonesCouncilConsidPermitIssD) > new Date(),
                    );
                } else if (filterFormState.status[0] === "Completed") {
                    filteredResults = filteredResults.filter(
                        (devapp) =>
                            devapp.milestonesCouncilConsidPermitIssD !== null &&
                            new Date(devapp.milestonesCouncilConsidPermitIssD) <= new Date(),
                    );
                }
            }
            if (filterFormState.neighbourhood?.length > 0 && filterFormState.neighbourhood?.length !== neighbourhoods.length) {
                filteredResults = filteredResults.filter(
                    (devapp) =>
                        devapp.neighbourhood !== "" &&
                        filterFormState.neighbourhood
                            .map((neighbourhood) => neighbourhood?.toLowerCase())
                            .some((neighbourhood) => neighbourhood.includes(devapp.neighbourhood?.toLowerCase())),
                );
            }

            // if any of the filters have no selection, return 0 results
            if(filterFormState.developmentType?.length === 0 || filterFormState.status?.length === 0 || filterFormState.neighbourhood?.length === 0){
                filteredResults = [];
            }
        }
        setOverlayInfo(undefined);
        setFilteredSearchResults(filteredResults);
        updatePaginationDetails(1, filteredResults);

        // set end range of items count on page
        let tempEnd = applicationsPerPage;
        if (filteredResults.length < applicationsPerPage) {
            tempEnd = filteredResults.length;
        }

        if (filteredResults.length === 0) {
            setItemOffset(0);
        }
        setEndItemOffset(tempEnd);
        // reset map zoom when either 'reset' or 'apply' is clicked
        mapSelectParcel(null);
        setMapLocation(mapCenter);
        setResetMap(true);
        setResetPage(true); // go back to first page in list view
    };

    const getPlanStatus = (permitDate) => {
        if(permitDate === null || new Date(permitDate) > new Date()){
            return "Ongoing";
        } else if(permitDate !== null && new Date(permitDate) <= new Date()){
            return "Completed";
        }
    }

    const getMostRecentApplications = () => {
        let sortedApplications = devAppInfo.toSorted((a, b) => {
            return new Date(b.milestonesApplicationReceivedD) - new Date(a.milestonesApplicationReceivedD);
        });
        return sortedApplications.slice(0, 5);
    };

    const getDevelopmentTypes = (res) => {
        // todo: this function is here and in devapp-details.js, extract to somewhere else?

        {
            /* {[...new Set(overlayInfo.planCustomFieldTableCells.filter((tableCell) =>
        (tableCell.columnName == "Tenure" && developmentTypes.map(string => string.toLowerCase()).includes(tableCell.value.toLowerCase()))
        ).map(tableCell => tableCell.value))].join(', ')} */
        }
        let typesList = [];
        for (let field of res) {
            if (field.columnName.includes("(sqm)") && field.value !== null) {
                if (!typesList.includes(field.columnName.substring(0, field.columnName.length - 5))) {
                    typesList.push(field.columnName.substring(0, field.columnName.length - 5));
                }
            }
        }
        if (typesList.length === 0) {
            return "TBD";
        } else if (typesList.length > 1) {
            return "Mixed use";
        } else {
            return typesList[0];
        }
    };

    const getMainImage = () => {
        let mainImage = {};
        let imageInfo = overlayInfo.planCustomFieldTableCells.filter(
            (field) => field.tableName === "PL - Sig Dev Images",
        );
        let numRows = Math.max(...imageInfo.map((info) => info.rowNumber));

        for (let i = 0; i <= numRows; i++) {
            let isLeadImage =
                imageInfo.find((cell) => cell.columnName === "Lead Image" && cell.rowNumber === i)?.value === "1";

            if (i === 0 || isLeadImage) {
                mainImage.src = imageInfo.find((cell) => cell.columnName === "URL" && cell.rowNumber === i)?.value;
                // let description = imageInfo.find(
                //     (cell) => cell.columnName === "Description" && cell.rowNumber === i
                // )?.value;
                mainImage.alt = imageInfo.find(
                    (cell) => cell.columnName === "Alternate Text" && cell.rowNumber === i,
                )?.value;
            }
        }
        setMainImage(mainImage);
    };

    const formatFilterValues = (selectedValues, targetWidth) => {
        let strLen = 25;
        const filterValues = selectedValues.join(", ");
        const capsCount = (filterValues.match(/[A-Z]/g) || []).length;
        // 74 = padding, 25 = badge width
        const availWidth = targetWidth - 70 - 25;
        const textWidth = (filterValues.length - capsCount) * 6 + capsCount * 10;

        let tempStr = filterValues;
        let remainStr = "";
        if (textWidth >= availWidth) {
            // using 10 as avg char width in px
            const allowedCharCount = availWidth / 10;
            tempStr = filterValues.substr(0, allowedCharCount - 1).trim();
            // check if tempStr ends with comma
            if (tempStr.charAt(tempStr.length - 1).indexOf(",") === 0) {
                tempStr = tempStr.substring(0, tempStr.length - 1);
            }
            tempStr = tempStr + "...";
        }

        const remainArr = remainStr.split(",");

        // count number of ',' in string
        const commasCount = tempStr.match(/,/g)?.length || 0;

        let badgeHtml = "";
        // const remainArrLen = remainArr.filter((s) => s.indexOf(" ") === 0)?.length;
        const remainLen = selectedValues.length - (commasCount + 1);
        if (remainLen > 0) {
            badgeHtml = `<span class="selected-count">+${remainLen}</span>`;
        }
        return tempStr + badgeHtml;
    };

    // to get filter dropdown widths when window resizes
    useEffect(() => {
        // Handler function to update the state
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Attach the event listener
        window.addEventListener("resize", handleResize);

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (selectHoodsRef.current) {
            const { offsetWidth, offsetHeight } = selectHoodsRef.current;
            setHoodsWidth(offsetWidth);
        }
        if (selectDevRef.current) {
            const { offsetWidth, offsetHeight } = selectDevRef.current;
            setDevWidth(offsetWidth);
        }
    }, [windowWidth]);

const parseAddress = (address) => {
        // Assumes number is first word, and the rest is the street name
        const parts = address.split(" ");
        const streetNumber = parseInt(parts[0], 10);
        const streetName = parts.slice(1).join(" ");
        return { streetNumber, streetName };
    };

const handleSorting = (sortField, sortOrder) => {
    // const sortArr = mapListViewArray(filteredSearchResults);
    if (sortField !== "planAddress") {
      const sorted = filteredSearchResults.sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      console.log(sorted);
      updatePaginationDetails(1, sorted);
      setResetPage(true);
    } else {
        const sortedAdd = filteredSearchResults.sort(function(a, b) {
            
            const addrA = parseAddress(a.planAddress);
            const addrB = parseAddress(b.planAddress);

            // Sort by street name alphabetically
            if(sortOrder === "asc"){
                if (addrA.streetName < addrB.streetName) {
                    return -1; // addrA comes first
                }
                if (addrA.streetName > addrB.streetName) {
                    return 1; // addrB comes first
                }
            } else {
                // descending order
                if (addrA.streetName > addrB.streetName) {
                    return -1; 
                }
                if (addrA.streetName < addrB.streetName) {
                    return 1; 
                }
            }

            // If street names are the same, sort by street number numerically
            // This handles cases like "1 E. Main Street" and "10 E. Main Street"
            if(sortOrder === "asc"){
                return addrA.streetNumber - addrB.streetNumber;
            } else {
                return addrB.streetNumber - addrA.streetNumber;
            }

        });

        updatePaginationDetails(1, sortedAdd);
        setResetPage(true);
    }
  };

const handleSortingChange = (event, accessor) => {
    // console.log(accessor);
    // console.log(event);

    const sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  };

const mapListViewArray = (arr) =>{
    const mappedArr = arr.map((a) => ({
        ...a,
        planAddress: a.planCaseAddresses !== null ? a.planCaseAddresses.find((address) => address.isMain)?.address.toLowerCase().trim() : "",
        neighbourhood: a.neighbourhood,
        status: getPlanStatus(a.milestonesCouncilConsidPermitIssD),
        plurlSlugT: a.plurlSlugT
    }));
    console.log(mappedArr);
    return mappedArr;
}

    return (
        <main className="dev-apps-map-search">
            <div className="search-container">
                <div className="search">
                    <div className="header">Find an application</div>
                    <div className="subheader">Look up an application address</div>
                    <div className="search-input">
                        <Autocomplete
                            open={acListOpen}
                            freeSolo
                            options={devAppInfo
                                .map((devapp, ind) => devapp.planAddress)
                                .filter((result) => result.trim() !== "")}
                            renderInput={(params) => <TextField className="search-input-text" {...params}
                            inputProps={{
                                ...params.inputProps,
                                onKeyDown: (e) => {
                                    // pressing enter should not trigger search
                                    if (e.key === "Enter") {
                                        e.stopPropagation();
                                    }
                                },
                                }} />}
                            onChange={(event, value) => {
                                getSearchResults(value);
                            }}
                            onInputChange={(event, value) => {
                                setSearchText(value);
                                if(value.length === 0){
                                    setFilteredSearchResults(devAppInfo);
                                    setResetMap(true);
                                    setShowNoResults(false);
                                    setACListOpen(false);
                                } else {
                                    setACListOpen(true);
                                }
                            }}
                           onClose={() => setACListOpen(false)}
                            inputValue={searchText}
                            className="search-input"
                        />
                    </div>
                    {showNoResults && (
                        <div className="no-results">
                            No results match this application address.
                        </div>
                    )}
                    {/* <button className="form-btn-submit" onClick={() => getSearchResults(searchText)}>
                        Search
                    </button> */}
                    <div className="subheader">Most recent applications:</div>
                    <div className="devapp-address">
                        {getMostRecentApplications().map((application, i) => (
                            <Link key={i} to={application.plurlSlugT}>
                                {application.planAddress.toLowerCase()}
                            </Link>
                        ))}
                    </div>
                </div>
                <div className="filter layout">
                    <div className="header">Filters</div>

                    <form className="filter-form" onSubmit={applyFilters} onReset={applyFilters}>
                        <div className="subheader">Development type</div>
                        <FormControl sx={{ m: 1 }}>
                            <InputLabel>No development types selected</InputLabel>
                            <Select
                                ref={selectDevRef}
                                multiple
                                value={filterFormState.developmentType}
                                onChange={onChangeHandler}
                                name="developmentType"
                                MenuProps={{
                                    PaperProps: {
                                        className: "filter-dropdown-popover",
                                    },
                                }}
                                label="Select development type(s)"
                                // input={<OutlinedInput label='Tag' />}
                                renderValue={(selected) =>
                                    selected.length === developmentTypes.length ? (
                                        <>All types of development</>
                                    ) : (
                                        <div
                                            className="filter-values"
                                            dangerouslySetInnerHTML={{ __html: formatFilterValues(selected, devWidth) }}
                                        ></div>
                                    )
                                }
                            >
                                <MenuItem className="select-deselect-all" value="Select / Deselect all" disableRipple>
                                    Select / Deselect all
                                </MenuItem>
                                {developmentTypes.map((type) => (
                                    <MenuItem key={type} value={type} disableRipple>
                                        <Checkbox checked={filterFormState.developmentType.includes(type)} />
                                        <ListItemText primary={type} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <div className="subheader">Status</div>
                        <FormControl sx={{ m: 1 }}>
                            <InputLabel>No statuses selected</InputLabel>
                            <Select
                                ref={selectHoodsRef}
                                className="filter-select"
                                multiple
                                value={filterFormState.status}
                                onChange={onChangeHandler}
                                name="status"
                                MenuProps={{
                                    PaperProps: {
                                        className: "filter-dropdown-popover",
                                    },
                                }}
                                input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) =>
                                    selected.length === 2 ? <>All statuses</> : <>{selected.join(", ")}</>
                                }
                            >
                                <MenuItem className="select-deselect-all" value="Select / Deselect all" disableRipple>
                                    Select / Deselect all
                                </MenuItem>
                                {["Ongoing", "Completed"].map((type) => (
                                    <MenuItem key={type} value={type} disableRipple>
                                        <Checkbox checked={filterFormState.status.includes(type)} />
                                        <ListItemText primary={type} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <div className="subheader">Neighbourhood</div>
                        <FormControl sx={{ m: 1 }}>
                            <InputLabel>No neighbourhoods selected</InputLabel>
                            <Select
                                className="filter-select"
                                multiple
                                value={filterFormState.neighbourhood}
                                onChange={onChangeHandler}
                                name="neighbourhood"
                                MenuProps={{
                                    PaperProps: {
                                        className: "filter-dropdown-popover",
                                    },
                                }}
                                input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) =>
                                    selected.length === neighbourhoods.length ? (
                                        <>All neighbourhoods</>
                                    ) : (
                                        <div
                                            className="filter-values"
                                            dangerouslySetInnerHTML={{
                                                __html: formatFilterValues(selected, hoodsWidth),
                                            }}
                                        ></div>
                                    )
                                }
                            >
                                <MenuItem className="select-deselect-all" value="Select / Deselect all" disableRipple>
                                    Select / Deselect all
                                </MenuItem>
                                {neighbourhoods.map((neighbourhood) => (
                                    <MenuItem key={neighbourhood} value={neighbourhood} disableRipple>
                                        <Checkbox checked={filterFormState.neighbourhood.includes(neighbourhood)} />
                                        <ListItemText primary={neighbourhood} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <div className="form-btn-container">
                            <button type="submit" className="form-btn-submit">
                                Apply
                            </button>
                            <button type="reset" className="form-btn-back">
                                Reset all filters
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Tabs tabs={tabs} selected={selected} setSelected={chooseSelected}>
                {/*--------------   Calendar List    -------------------*/}
                <TabContent id={0} tab={tabs[0]} selected={selected}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            className: "tab-container",
                        }}
                    ></div>
                    <div className="results-count">Displaying {filteredSearchResults.length} results</div>
                    <MapContainer
                        center={mapLocation}
                        // scrollWheelZoom={false}
                        style={{ height: "622px" }}
                        className="simplicity-forms-location"
                        zoomControl={true}
                        keyboard={true}
                        minZoom={minMapZoom}
                        maxZoom={maxMapZoom}
                        maxBounds={bounds}
                        crs={crs}
                    >
                        <TileLayer url="https://www.geoweb.dnv.org/arcgis/rest/services/Basemap_Canvas/MapServer/tile/{z}/{y}/{x}" />

                        <MarkerClusterGroup>
                            {filteredSearchResults.length !== 0 &&
                                filteredSearchResults.map((result, ind) => {
                                    return (
                                        <Marker
                                            key={`marker-${ind}`}
                                            position={[result.latitude, result.longitude]}
                                            icon={icon}
                                            // eventHandlers={{ click: () => {
                                            //     mapSelectParcel(result);
                                            //     console.log("marker clicked");
                                            // }}}
                                            eventHandlers={{
                                                add: (e) => {
                                                    const marker = e.target;
                                                    // Add keyboard listener directly to the DOM element
                                                    marker._icon.addEventListener("keydown", (keyEvent) => {
                                                        if (keyEvent.key === "Enter") {
                                                            // console.log("Marker focused and Enter pressed!");
                                                            mapSelectParcel(result);
                                                        }
                                                    });
                                                },
                                                click: () => mapSelectParcel(result),
                                            }}
                                        ></Marker>
                                    );
                                })}
                        </MarkerClusterGroup>

                        <ChangeLocation
                            location={mapLocation}
                            zoom={mapZoom}
                            overLayInfo={overlayInfo}
                            resetMap={resetMap}
                            setResetMap={setResetMap}
                        />

                        {overlayInfo !== undefined && (
                            <div className="info-window-overlay">
                                <div className="info-window">
                                    <div className="header-wrapper">
                                        <div className="header">
                                            {overlayInfo.planAddress.toLowerCase()}
                                        </div>
                                        <button
                                            className="btn-close"
                                            type="button"
                                            onClick={() => {
                                                setOverlayInfo(undefined);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={solid.faXmark} size={"xl"} />
                                        </button>
                                    </div>
                                    <div className="details">
                                        <div className="left">
                                            <div className="sub-head">Project details</div>
                                            <table className="project-details">
                                                <tbody>
                                                    <tr>
                                                        <td className="cell-head">Project name</td>
                                                        <td className="cell-content proj-name">
                                                            {overlayInfo.prjProjectNameS}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="cell-head">Submitted</td>
                                                        <td className="cell-content no-wrap">
                                                            {formatDate(
                                                                overlayInfo.milestonesApplicationReceivedD,
                                                                Config.dateFormat.date,
                                                            )}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="cell-head">Status</td>
                                                        <td className="cell-content">
                                                            {" "}
                                                            {overlayInfo.MilestonesCouncilConsidPermitIssD === null ||
                                                            new Date(overlayInfo.MilestonesCouncilConsidPermitIssD) >
                                                                new Date()
                                                                ? "Ongoing"
                                                                : "Completed"}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div className="sub-head">Additional information</div>
                                            <table className="additional-info">
                                                <tbody>
                                                    <tr>
                                                        <td className="column">
                                                            <span className="span-head">Total units</span>
                                                            <span>{overlayInfo.plunitcountSUM}</span>
                                                        </td>
                                                        <td className="column">
                                                            <span className="span-head">Total lot area</span>
                                                            <span>
                                                                {Math.round(overlayInfo.siteAreaN).toLocaleString(
                                                                    "en-CA",
                                                                )}{" "}
                                                                m<sup>2</sup> /{" "}
                                                                {Math.round(overlayInfo.siteAreaFtN).toLocaleString(
                                                                    "en-CA",
                                                                )}{" "}
                                                                ft
                                                                <sup>2</sup>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span className="span-head">Development type</span>
                                                            <span>
                                                                {getDevelopmentTypes(
                                                                    overlayInfo.planCustomFieldTableCells.filter(
                                                                        (field) =>
                                                                            field.tableName === "Pl Building Proposed",
                                                                    ),
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <Link
                                                to={overlayInfo.plurlSlugT}
                                                className="form-btn-next button-left"
                                            >
                                                Go to application details{" "}
                                                <FontAwesomeIcon icon={solid.faChevronRight} />
                                            </Link>
                                        </div>
                                        <div className="right">
                                            <img src={mainImage.src} alt={mainImage.alt}></img>
                                            <Link
                                                to={overlayInfo.plurlSlugT}
                                                className="form-btn-next"
                                            >
                                                Go to application details{" "}
                                                <FontAwesomeIcon icon={solid.faChevronRight} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </MapContainer>
                </TabContent>

                {/*--------------   Results List    -------------------*/}
                <TabContent id={1} tab={tabs[1]} selected={selected} className="table-view">
                     <div className="loading-indicator table-view">

                        <p>
                            {filteredSearchResults.length > 0 && (
                                <>
                                {itemOffset} to {endItemOffset} of {filteredSearchResults.length} results
                                </>
                            )}
                            {filteredSearchResults.length === 0 && (
                                <>
                                0 results
                                </>
                            )}
                            
                        </p>

                    </div>

                    <div className="template-wrap">
                        <div className="table_wrapper_outer">
                            <div className="results-table table_wrapper">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="devapp-address" 
                                            >
                                                <button onClick={(event) =>
                                                handleSortingChange(event, "planAddress")
                                            }>
                                                Application
                                            {(sortField === "planAddress") && 
                                                <span className={order}>
                                                    <FontAwesomeIcon icon={solid.faSortUp} />
                                                    <FontAwesomeIcon icon={solid.faSortDown} />
                                                </span>
                                            }
                                            </button>
                                            </th>
                                            <th className="neighbourhood">
                                                <button onClick={(event) =>
                                                handleSortingChange(event, "neighbourhood")
                                            }>Neighbourhood
                                               {(sortField === "neighbourhood") && 
                                                <span className={order}>
                                                    <FontAwesomeIcon icon={solid.faSortUp} />
                                                    <FontAwesomeIcon icon={solid.faSortDown} />
                                                </span>
                                            }
                                            </button>
                                            </th> 
                                            <th className="status">
                                                <button onClick={(event) =>
                                                handleSortingChange(event, "status")
                                            }>Status
                                               {(sortField === "status") && 
                                                <span className={order}>
                                                    <FontAwesomeIcon icon={solid.faSortUp} />
                                                    <FontAwesomeIcon icon={solid.faSortDown} />
                                                </span>
                                            }
                                                </button>
                                           
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isArrayNotEmpty(paginationDisplayableApplications) &&
                                            paginationDisplayableApplications.map((res, index) => {
                                                // const { Id } = model
                                                return (
                                                    <tr key={index}>
                                                        <td className="devapp-address">
                                                            <Link to={res.plurlSlugT}>
                                                                {res.planAddress}
                                                            </Link>
                                                        </td>
                                                        <td className="neighbourhood">
                                                            {res.neighbourhood}
                                                        </td>
                                                        <td className="status">
                                                            {res.status}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {isArrayEmpty(paginationDisplayableApplications) && (
                                            <tr>
                                                <td>There are no applications to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="drop-shadow"></div>
                        </div>
                        <PaginationControl
                            contentPerPage={applicationsPerPage}
                            totalContentLength={filteredSearchResults.length}
                            onPaginationUpdate={updatePaginationDetails}
                            isFirstPage={resetPage}
                            setIsFirstPage={setResetPage}
                        />
                    </div>

                </TabContent>
            </Tabs>
        </main>
    );
};

DnvMapSearch.displayName = "DnvMapSearch";
export { DnvMapSearch };
